import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { FileTypeEnum } from '@repo/toolkit/types'
import UploadFileInput from '@repo/ui/file-input'
import { UploadLogoIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { CseInput } from '../../../lib/types/models/cse/cse'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'

const CseBasicDetailsFormSection = () => {
  const form = useFormContext<CseInput>()
  return (
    <InnerBox className="bg-primary-light border-primary-light-active rounded-xl" title="CSE">
      <div className="flex flex-col gap-3">
        <FormField
          control={form.control}
          name="identifier"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  labelClassName="bg-primary-light"
                  inputClassName="bg-primary-light"
                  {...field}
                  required
                  label="Identifiant"
                  type="text"
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="label"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  labelClassName="bg-primary-light"
                  {...field}
                  required
                  label="Libellé"
                  type="text"
                />
              </FormControl>
            </FormItem>
          )}
        />

        <div className="flex flex-col gap-2">
          <Typography variant="label-semibold" className="text-grey">
            Statut *
          </Typography>
          <div className="flex items-center gap-3">
            <FormField
              control={form.control}
              name={'isActive'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Actif'}
                      checked={field.value === true}
                      onCheck={() => form.setValue('isActive', true, { shouldValidate: true })}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'isActive'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Inactif'}
                      checked={field.value === false}
                      onCheck={() => form.setValue('isActive', false, { shouldValidate: true })}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        <FormField
          control={form.control}
          name="code"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  labelClassName="bg-primary-light"
                  {...field}
                  required
                  label="Code partenaire"
                  type="text"
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name={'logo'}
          render={({ field }) => (
            <FormItem className={'flex-1'}>
              <FormControl>
                <UploadFileInput
                  types={[FileTypeEnum.IMAGE]}
                  placeholder="Glisser-déposer ou parcourir"
                  placeholderVariant="tag"
                  placeholderColor={tailwindColors.grey.lighter}
                  icon={UploadLogoIcon}
                  iconContainerClassName="bg-white"
                  hasError={!!form.formState.errors.logo}
                  previewOnClick
                  label={'Logo du CSE'}
                  files={field?.value ? [field?.value] : undefined}
                  onFilesChange={(files) => {
                    field.onChange(files.length === 0 ? null : files[0])
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="numberOfRegistrationsCurrentYear"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  labelClassName="bg-primary-light"
                  {...field}
                  label="Nombre d'inscriptions N"
                  type="number"
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="numberOfRegistrationsPreviousYear"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  labelClassName="bg-primary-light"
                  {...field}
                  label="Nombre d'inscriptions N - 1"
                  type="number"
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="numberOfRegistrationsTwoYearsAgo"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput
                  labelClassName="bg-primary-light"
                  {...field}
                  label="Nombre d'inscriptions N - 2"
                  type="number"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </InnerBox>
  )
}

export default CseBasicDetailsFormSection
